
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Innovacabonrentinhadapsar() {



    const cardData =
    {
        keyword: ' Innova Cab on Rent in Hadapsar Pune',
        heading: 'Prince Cabs: Innova Cab on Rent in Hadapsar Pune',
        headingDescription: 'Prince Cabs provides reliable Innova Cab on Rent in Hadapsar Pune, perfect for family trips, corporate travel, airport transfers, and outstation journeys. Our spacious and well-maintained Innova and Innova Crysta vehicles are equipped with modern amenities to ensure a safe and comfortable ride. With professional chauffeurs, flexible booking options, and transparent pricing, we make your travel completely hassle-free. Choose Prince Cabs’ trusted Innova cab rental service in Hadapsar Pune for convenience, affordability, and comfort.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

        "topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is one of the most iconic attractions in Mahabaleshwar, offering a tranquil setting surrounded by lush greenery. Visitors can enjoy boating, horse riding, and lakeside walks while soaking in the cool breeze. The lake is especially lively during evenings when families gather to relax by the water. Small food stalls serving local snacks make it a perfect picnic spot. During peak season, the reflections of surrounding hills create a picture-perfect scene. Its serene charm makes Venna Lake a must-visit for couples, families, and nature lovers."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a famous tourist spot known for its strawberry products, delicious food, and refreshing ambiance. Visitors can enjoy freshly prepared strawberry shakes, ice creams, and pizzas made with farm-fresh ingredients. The garden also has a chocolate factory, nursery, and retail outlet offering jams, syrups, and crushes. It becomes a hub of activity during the annual Strawberry Festival. The well-maintained lawns and colorful flowers add to its beauty. Mapro Garden is a delightful stop for foodies and families alike."
  },
  {
    "title": "Arthur's Seat Point",
    "description": "Arthur’s Seat Point is often called the ‘Queen of All Points’ in Mahabaleshwar due to its mesmerizing views of the deep valleys and Savitri River. The cliff provides a dramatic view of the dense forests on one side and barren plains on the other. It is also famous for the ‘floating of light objects’ phenomenon, where lightweight items seem to rise with the wind. The point is ideal for photography and witnessing magical sunsets. Trekkers and adventure seekers find the climb thrilling. Visiting Arthur’s Seat is a highlight for anyone exploring Mahabaleshwar."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic hill fort located about 20 km from Mahabaleshwar, built by Chhatrapati Shivaji Maharaj in 1656. The fort is famous for the legendary battle between Shivaji and Afzal Khan. Visitors can explore the strong fortifications, ancient temples, and monuments dedicated to Shivaji’s bravery. The climb offers panoramic views of the Sahyadri mountains. It is also surrounded by small eateries serving authentic Maharashtrian food. For history buffs and trekkers, Pratapgad is a perfect blend of heritage and adventure."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a striking viewpoint where a natural rock formation resembles an elephant’s trunk. Located near Lodwick Point, it offers breathtaking views of the valleys and surrounding hills. The spot is peaceful and perfect for spending quiet moments amidst nature. It is especially popular for sunrise and sunset photography. The cool breeze and panoramic backdrop make it a favorite among couples. Its unique geological shape gives Elephant’s Head Point a distinctive charm."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is one of Mahabaleshwar’s most scenic spots, cascading gracefully into the valley below. Surrounded by dense forest, it offers two viewpoints – a smaller waterfall ideal for a picnic and a larger one that creates a majestic plunge. The falls are at their most spectacular during the monsoon season. Visitors can trek down the trail for closer views and enjoy the soothing sound of gushing water. The lush greenery and misty ambiance create a magical experience. It’s a must-visit for photographers and nature enthusiasts."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point, also known as Sunrise Point, is the highest point in Mahabaleshwar at 1,439 meters above sea level. It offers a panoramic view of the surrounding hills and valleys, especially enchanting during sunrise and sunset. The plateau has three watchtowers to capture different angles of the landscape. On clear days, the view stretches endlessly across the horizon. Morning visitors are greeted with misty clouds and golden sunlight. It is a serene spot for meditation, yoga, or simply enjoying the natural beauty."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple is an ancient shrine dedicated to Lord Shiva, built in the 16th century by the rulers of the Maratha dynasty. It houses a 6-foot-long Shiva lingam considered to be ‘Swayambhu’ (self-originated). The temple is a significant pilgrimage site for devotees from across India. Its Hemadpanti-style architecture adds to its historical charm. Surrounded by hills, the temple exudes a divine and peaceful atmosphere. Festivals like Mahashivratri see large gatherings of devotees here."
  },
  {
    "title": "Panchgani",
    "description": "Located just 20 km from Mahabaleshwar, Panchgani is a scenic hill station famous for its strawberry farms, boarding schools, and colonial charm. It is surrounded by five hills of the Sahyadri range, offering breathtaking views of the Krishna Valley. Popular spots include Table Land, Sydney Point, and Parsi Point. Adventure lovers can try paragliding and trekking. Panchgani also has a rich history with colonial-era bungalows and churches. It’s an ideal day-trip destination from Mahabaleshwar."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak, formerly known as Mount Olympia, is one of Mahabaleshwar’s highest peaks. It offers stunning views of Venna Lake, Krishna Valley, and Pratapgad Fort. The peak is a favorite among trekkers and photographers seeking untouched natural beauty. It is also associated with historical figures, as it was renamed after the Duke of Connaught visited the site. The cool climate and serene surroundings make it perfect for a peaceful retreat. Sunset from Connaught Peak is a magical experience."
  }
],


       "services": [
    {
        "name": "Innova Car Rental in Pune",
        "description": "Experience the convenience and comfort of Innova car rentals across Pune. Whether for business trips, family outings, or city travel, our well-maintained Innova fleet ensures a smooth and luxurious ride. Professional drivers, flexible packages, and easy booking make your journey hassle-free."
    },
    {
        "name": "Innova Car Rental in Koregaon Park Pune",
        "description": "Avail top-quality Innova car rental services in Koregaon Park Pune, perfect for local travel, corporate needs, and sightseeing. Our reliable vehicles come with skilled drivers who know the area well, ensuring timely and comfortable rides in one of Pune’s most popular neighborhoods."
    },
    {
        "name": "Innova Car Rental in Kothrud Pune",
        "description": "Get the best Innova rental experience in Kothrud Pune with spacious, clean, and comfortable vehicles. Ideal for family trips, business errands, and daily commuting. Our drivers are professional and punctual, making your travel in and around Kothrud seamless and enjoyable."
    },
    {
        "name": "Innova Taxi Service in Hinjewadi",
        "description": "Reliable Innova taxi service in Hinjewadi catering to IT professionals, visitors, and locals. Our cabs provide comfortable rides to and from office locations, airports, and nearby suburbs. Book with us for affordable rates and timely pickups with courteous drivers."
    },
    {
        "name": "Innova Taxi Service in Kharadi",
        "description": "Efficient Innova taxi services in Kharadi offering hassle-free transportation for corporate clients, families, and tourists. Our clean and spacious vehicles, combined with experienced drivers, make daily commutes and outstation trips smooth and stress-free."
    },
    {
        "name": "Innova Taxi Service in Wadgaon Sheri",
        "description": "Get dependable Innova taxi services in Wadgaon Sheri, Pune. Our fleet is perfect for local travel, airport transfers, and outstation journeys. Enjoy the luxury of a spacious Innova with professional drivers who prioritize your comfort and safety."
    },
    {
        "name": "Innova Taxi Service in Swargate Pune",
        "description": "Offering trusted Innova taxi services in Swargate Pune for local commuting, city tours, and airport transfers. Our vehicles are well-maintained, and drivers are punctual, ensuring a comfortable ride for you and your family or colleagues."
    },
    {
        "name": "Innova Car Rental in Viman Nagar",
        "description": "Choose from a wide range of Innova car rentals in Viman Nagar for corporate travel, sightseeing, and personal use. Our vehicles are clean, well-serviced, and driven by professional chauffeurs who ensure a safe and pleasant journey in Pune's fast-growing area."
    },
    {
        "name": "Innova Car Rental in Baner Pune",
        "description": "Affordable and reliable Innova car rental services in Baner Pune, ideal for families, business travelers, and tourists. We provide flexible booking options and professional drivers to make your travel convenient and enjoyable in one of Pune’s bustling localities."
    },
    {
        "name": "Innova Taxi in Camp Pune",
        "description": "Book Innova taxi services in Camp Pune for hassle-free local travel, airport drop-offs, and sightseeing tours. Our clean and comfortable vehicles with experienced drivers ensure you reach your destination on time with ease and luxury."
    },
    {
        "name": "Affordable Innova Rental Hadapsar",
        "description": "Affordable Innova rental services in Hadapsar for daily commuting, corporate needs, and weekend trips. Our fleet offers clean, spacious vehicles driven by courteous professionals, ensuring value for money without compromising on comfort or service quality."
    },
    {
        "name": "Luxury Innova Cab in Hadapsar",
        "description": "Experience luxury travel in Hadapsar with our premium Innova cab services. Perfect for weddings, corporate events, airport transfers, and family outings, our Innova fleet offers spacious interiors, excellent comfort, and professional chauffeurs dedicated to providing a superior travel experience."
    }
],
"tableData": [
    ["Innova Car Rental in Pune", "Innova Car Rental in Koregaon Park Pune"],
    ["Innova Car Rental in Kothrud Pune", "Innova Taxi Service in Hinjewadi"],
    ["Innova Taxi Service in Kharadi", "Innova Taxi Service in Wadgaon Sheri"],
    ["Innova Taxi Service in Swargate Pune", "Innova Car Rental in Viman Nagar"],
    ["Innova Car Rental in Baner Pune", "Innova Taxi in Camp Pune"],
    ["Affordable Innova Rental Hadapsar", "Luxury Innova Cab in Hadapsar"]
],


    "whychoose": [
    {
        "WhyChooseheading": "Reliable Innova Cab on Rent in Hadapsar, Pune",
        "WhyChoosedescription": "Prince Cabs offers trusted Innova cab rental services in Hadapsar, Pune, perfect for business trips, family outings, airport transfers, and local sightseeing. Our well-maintained Innova vehicles provide a spacious and comfortable ride, ensuring a smooth travel experience around Hadapsar and nearby areas."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles",
        "WhyChoosedescription": "Our Toyota Innova cabs are equipped with ergonomic seating, ample legroom, and large luggage capacity. Whether you’re traveling alone or with a group, our cabs ensure maximum comfort for short city rides or longer journeys from Hadapsar."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our professional drivers are familiar with Hadapsar’s roads and Pune’s traffic patterns. They ensure timely pickups and drop-offs while driving safely and courteously, providing you a stress-free and punctual travel experience."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
        "WhyChoosedescription": "Prince Cabs offers customizable rental options including hourly hires, full-day rentals, or outstation trips starting from Hadapsar. You can book easily through phone, WhatsApp, or online, and choose packages that best fit your travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "We provide clear and competitive pricing for Innova cab rentals in Hadapsar with no hidden charges. Payment options include UPI, credit/debit cards, net banking, and cash, ensuring a smooth and secure transaction process."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Standards",
        "WhyChoosedescription": "All Innova cabs are thoroughly sanitized before and after each trip. Regular maintenance and safety checks guarantee a clean, safe, and comfortable journey every time you rent with Prince Cabs in Hadapsar."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our customer service team is available round the clock to assist with Innova cab bookings in Hadapsar, ensuring prompt responses, smooth coordination, and a worry-free rental experience."
    }
]

















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Innova cab on rent in Hadapsar, Pune?',
        answer: 'Yes, Prince Cabs provides Innova cabs on rent in Hadapsar for local travel, airport transfers, and outstation trips with flexible rental packages.',
    },
    {
        question: 'What are the rental options for Innova cabs in Hadapsar?',
        answer: 'You can rent Innova cabs on an hourly basis for local rides or book full-day and outstation packages depending on your travel needs.',
    },
    {
        question: 'How do I book an Innova cab in Hadapsar?',
        answer: 'Booking is easy—call Prince Cabs or visit our website, mention your pickup location as Hadapsar, and we will assign a clean, well-maintained Innova cab promptly.',
    },
    {
        question: 'Are Innova cabs available for airport transfers from Hadapsar?',
        answer: 'Yes, we offer reliable and punctual airport transfer services from Hadapsar to Pune Airport and other nearby airports in a comfortable Innova cab.',
    },
    {
        question: 'Is there a minimum rental duration for Innova cabs in Hadapsar?',
        answer: 'Minimum rental durations may apply for hourly packages, typically starting from 4 hours, but outstation trips can be customized as per your requirements.',
    },
    {
        question: 'Are the Innova cabs sanitized and safe?',
        answer: 'Yes, all Innova cabs are regularly sanitized, cleaned, and serviced. Our drivers are professional, background-verified, and prioritize your safety.',
    },
    {
        question: 'What is the fare for renting an Innova cab in Hadapsar?',
        answer: 'Fares depend on the rental duration, distance, and type of trip. Contact Prince Cabs for a personalized quote tailored to your travel plan.',
    },
];

const testimonials = [
    {
        name: "Mr. Sandeep More",
        position: "Local Resident",
        text: "I rented an Innova cab from Hadapsar for a day trip. The car was very comfortable and the driver was courteous. Excellent service by Prince Cabs.",
        image: "/img/testimonial/testimonial-thumb-hadapsar-1.png",
    },
    {
        name: "Ms. Priya Kulkarni",
        position: "Business Traveler",
        text: "Prince Cabs made it easy to rent an Innova from Hadapsar. The booking was quick, and the cab arrived on time. Highly recommended for Hadapsar residents.",
        image: "/img/testimonial/testimonial-thumb-hadapsar-2.png",
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cab on Rent in Hadapsar Pune",
  "image": "https://princecab.com/assets/images/innova-cab-hadapsar-pune.jpg",
  "description": "Rent Innova cabs in Hadapsar Pune with Prince Cabs. Affordable, luxury Innova rental services available in Hadapsar and nearby areas like Koregaon Park, Kothrud, Kharadi, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.72",
    "ratingCount": "6900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/innova-cab-rent-hadapsar-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Innova Cab on Rent in Hadapsar Pune | Affordable & Luxury Innova Rental | Prince Cabs</title>
  <meta
    name="description"
    content="Rent Innova cabs in Hadapsar Pune with Prince Cabs. Affordable, luxury Innova rental services available in Hadapsar and nearby areas like Koregaon Park, Kothrud, Kharadi, and more."
  />
  <meta
    name="keywords"
    content="Innova Car Rental in Pune, Innova Car Rental in Koregaon Park Pune, Innova Car Rental in Kothrud Pune, Innova Taxi Service in Hinjewadi, Innova Taxi Service in Kharadi, Innova Taxi Service in Wadgaon Sheri, Innova Taxi Service in Swargate Pune, Innova Car Rental in Viman Nagar, Innova Car Rental in Baner Pune, Innova Taxi in Camp Pune, Affordable Innova Rental Hadapsar, Luxury Innova Cab in Hadapsar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacabonrentinhadapsar ;